import filesUploadStoreFactory from 'hooks/filesUploadStoreFactory';

const useRepositoryFilesUploadStore = filesUploadStoreFactory();

export default useRepositoryFilesUploadStore;
